import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import pro from '../assets/images/pro.jpg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={pro} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/syed-ahmed-dev" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/syed-muhammad-ahmed-2236a0251/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h2>Syed Muhammad Ahmed</h2>
          <p>Backend Developer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/syed-ahmed-dev" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/syed-muhammad-ahmed-2236a0251/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;